var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import 'knockout-postbox';
import page from 'page';
import layout from "../app/layout";
import { Topics } from "../app-lib/constants";
import * as authorization from "./authorization";
import './knockout_router';
import { PageOption, RouteData } from './page-component';
var animation = "fade"; //
var inClass = animation + "In";
var outClass = animation + "Out";
var pageClass = "pt-page";
var currentPageClass = "pt-page-current";
var layoutClass = "page-layout";
var currentLayoutClass = "page-layout-current";
var App = /** @class */ (function () {
    function App() {
        var _this = this;
        this.pageCache = { length: 0 };
        this.disabeDataCache = true;
        this.disabePageCache = false;
        this.isNavigating = false;
        if (!history["emulate"])
            page.base(location.pathname + "#");
        this.initLayoutContainer();
        page('/:controller/:action/:id?', function (ctx, next) {
            //console.log(ctx.params);
            if (_this.onNavigating) {
                var cancel = _this.onNavigating(ctx.params);
                ctx.handled = !cancel;
                return;
            }
            // //if (Configs.loginUrl !== `/${ctx.params.controller}/${ctx.params.action}` && !authorization.isLogin()) {
            if ("" + ctx.params.controller !== 'account' && !authorization.isLogin()) {
                authorization.navigateToLoginUrl();
                return;
            }
            // console.log(`${new Date().toISOString()}:${ctx.path}`)
            if (_this.isNavigating) {
                console.warn(new Date().toISOString() + ":isNavigating");
                ctx.handled = true;
                return;
            }
            _this.isNavigating = true;
            _this.loadPageFromPageJSContext(ctx).then(function () { return _this.isNavigating = false; });
        });
        page(function () { return authorization.navigateToLoginWhenNeeded(); });
        page({ click: false, dispatch: true, hashbang: false, popstate: true });
    }
    App.prototype.loadPage = function (params) {
        var _this = this;
        //this.now1 = performance.now();
        this.isNavigating = true;
        var newPageComponentOption = new PageOption(params, this.pageCache.length);
        if (this.currentPageComponent) {
            if (this.currentPageComponent.options.routeData.equals(newPageComponentOption.routeData))
                return Promise.resolve();
            if (this.currentPageComponent && this.currentPageComponent.onPause)
                this.currentPageComponent.onPause();
        }
        return this.loadPageContent(newPageComponentOption)
            .then(function (result) { return __awaiter(_this, void 0, void 0, function () {
            var pageComponent;
            return __generator(this, function (_a) {
                pageComponent = result.pageComponent;
                if (result.isFromCache) {
                }
                if (pageComponent.hasLayout) {
                    if (!this.contentContainer || this.contentContainer.id !== this.contentWithLayoutContainer.id) {
                        this.rootContainer.children[0].classList.add(currentLayoutClass);
                        this.rootContainer.children[1].classList.remove(currentLayoutClass);
                        this.contentContainer = this.contentWithLayoutContainer;
                    }
                }
                else {
                    this.rootContainer.children[0].classList.remove(currentLayoutClass);
                    this.rootContainer.children[1].classList.add(currentLayoutClass);
                    this.contentContainer = this.contentWithoutLayoutContainer;
                }
                if (!result.isFromCache) {
                    this.contentContainer.appendChild(pageComponent.container);
                    if (!this.disabePageCache) {
                        this.pageCache[pageComponent.options.routeData.routeKey] = pageComponent;
                        this.pageCache.length++;
                    }
                    pageComponent.onInitComplete();
                }
                else {
                    if (pageComponent.onResume) {
                        pageComponent.onResume();
                    }
                }
                // if (this.currentPageComponent)
                //     this.currentPageComponent.animate = outClass + 'Left';
                // option.animate = inClass + 'Right';
                this.animatePage(this.currentPageComponent, pageComponent);
                this.currentPageComponent = pageComponent;
                if (this.onNavigateTo) {
                    this.onNavigateTo(pageComponent.options.routeData);
                }
                ko.postbox.publish(Topics.app_location_changed, pageComponent.options.routeData.routeKey);
                return [2 /*return*/];
            });
        }); }).catch(function (reason) {
            if (reason.handled)
                return;
            console.error(reason);
            if (_this.onNavigateFailed) {
                _this.onNavigateFailed(reason);
                return;
            }
            if (reason && reason.message == "401")
                return authorization.signOut();
            //alert("An error has occurred...");
        });
    };
    App.prototype.loadPageFromPageJSContext = function (ctx) {
        var params = new RouteData(ctx);
        // if (!params.isValid()) {
        //     this.isNavigating = false 
        //     return Promise.resolve()
        // }
        return this.loadPage(params);
    };
    App.prototype.loadPageContent = function (page) {
        var pageCache = (this.pageCache[page.routeData.routeKey] || { options: {} });
        var cachedDomId = pageCache.options.domId;
        var promise;
        if (cachedDomId) {
            page.domId = cachedDomId;
            pageCache.isNeedUpdate = pageCache.options.routeData.equals(page.routeData);
            pageCache.options = page;
            promise = this.loadCachedPageContent(pageCache);
            page = null;
        }
        else {
            promise = this.loadnewPageContent(page);
        }
        return promise;
    };
    App.prototype.loadCachedPageContent = function (pageComponent) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.disabeDataCache)
                            if (!pageComponent.isNeedUpdate)
                                return [2 /*return*/, Promise.resolve({ isFromCache: true, pageComponent: pageComponent })];
                        return [4 /*yield*/, pageComponent.update(pageComponent.options)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve({ isFromCache: true, pageComponent: pageComponent })];
                }
            });
        });
    };
    App.prototype.loadnewPageContent = function (option) {
        var _this = this;
        var p55 = option.routeData.controller;
        var p56 = option.routeData.action;
        return import(
        /* webpackChunkName: "app" */
        /* webpackMode: "eager" */
        "../app/" + p55 + "/" + p56 + ".ts")
            .then(function (result) { return __awaiter(_this, void 0, void 0, function () {
            var viewModelFactory, html, pageComponent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        viewModelFactory = result.default;
                        return [4 /*yield*/, import(
                            /* webpackChunkName: "app" */
                            /* webpackMode: "eager" */
                            "../app/" + p55 + "/" + p56 + ".html")];
                    case 1:
                        html = _a.sent();
                        html = html.default;
                        pageComponent = new viewModelFactory(html).initComponent(option);
                        pageComponent.container.id = option.domId;
                        pageComponent.container.className = pageClass;
                        pageComponent.container.setAttribute("data-url", option.routeData.routeKey);
                        return [4 /*yield*/, pageComponent.update(pageComponent.options)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, { pageComponent: pageComponent, isFromCache: false }];
                }
            });
        }); });
    };
    App.prototype.initLayoutContainer = function () {
        this.rootContainer = document.getElementById("rootContainer");
        var layoutComponent = layout.initComponent();
        layoutComponent.renderTo(this.rootContainer);
        layoutComponent.update().then(function () { return layoutComponent.onInitComplete(); });
        layoutComponent.container.classList.add("" + currentLayoutClass);
        var withoutLayoutContainer = document.createElement("div");
        withoutLayoutContainer.className = "withoutLayoutContainer " + layoutClass;
        this.rootContainer.appendChild(withoutLayoutContainer);
        this.contentWithLayoutContainer = layoutComponent.container.querySelector("#contentContainer");
        this.contentWithoutLayoutContainer = withoutLayoutContainer;
    };
    App.prototype.animatePage = function (oldPage, newPage) {
        if (oldPage) {
            //container pt-page pt-page-current
            var oldPageDom = this.rootContainer.querySelector("#" + oldPage.options.domId);
            if (oldPageDom) {
                if (this.disabePageCache)
                    oldPageDom.remove();
                else {
                    oldPageDom.classList.remove(currentPageClass);
                }
            }
            //oldPageDom["animateCss"](oldPage.animate);
        }
        if (newPage) {
            console.log('0.0');
            ko.postbox.publish(Topics.app_location_changed, new Date().getMilliseconds());
            var newPageDom_1 = this.contentContainer.querySelector("#" + newPage.options.domId);
            if (newPageDom_1) {
                requestAnimationFrame(function () { return newPageDom_1.classList.add(currentPageClass); });
                //newPageDom.classList.add(currentPageClass);
            }
        }
        // newPageDom["animateCss"](newPage.animate);
    };
    return App;
}());
export default App;
